export const pushToDataLayer = (eventName, payload = {}) => {
    if (!window.dataLayer) {
        window.dataLayer = [];
    }

    window.dataLayer.push({
        event: eventName,
        ...payload,
    });
};

export const trackPageView = ({ page_title, page_path, page_location }) => {
    pushToDataLayer('page_view', {
        page_title,
        page_path,
        page_location,
    });
};

export const trackCompleteRegistration = ({ method = 'email' } = {}) => {
    pushToDataLayer('complete_registration', {
        method,
    });
};

export const trackInitiateCheckout = ({
    currency = 'USD',
    value,
    plan_name,
    plan_id,
} = {}) => {
    pushToDataLayer('initiate_checkout', {
        currency,
        value,
        plan_name,
        plan_id,
    });
};

export const trackPurchase = ({
    transaction_id,
    value,
    currency = 'USD',
    plan_name,
    plan_id,
} = {}) => {
    pushToDataLayer('purchase', {
        transaction_id,
        value,
        currency,
        plan_name,
        plan_id,
    });
};